<mat-form-field appearance="none">
  <div
    matAutocompleteOrigin
    class="autocomplete-origin"
    #origin="matAutocompleteOrigin"
    [class.is-focus]="isFocus"
  >
    <studio-button-legacy
      #inputSearch
      class="button-search"
      (click)="onFocus()"
      theme="transparent"
    >
      <studio-icon inputSearch name="search" size="20"></studio-icon>
    </studio-button-legacy>
    <mat-chip-list #chipList (change)="chipsChange()" [class.has-chips]="selectedChips.length">
      <mat-chip
        *ngFor="let chip of selectedChips"
        selectable="true"
        removable="true"
        [ngClass]="chip.type || 'primary'"
        (removed)="removeChip(chip[displayKey])"
      >
        {{ chip.text }}
        <studio-icon matChipRemove name="close" size="10"></studio-icon>
      </mat-chip>
      <input
        #input
        [placeholder]="placeholder"
        [formControl]="formCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matAutocompleteConnectedTo]="origin"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
        (blur)="addOnBlur($event)"
        (focus)="onFocus()"
        matChipInputAddOnBlur="false"
      />
    </mat-chip-list>
    <studio-tooltip id="clearButtonTooltip" triggerType="mouseenter" placement="top">
      <div slot="content">
        <p class="text">{{ clearButtonTooltipText }}</p>
      </div>
      <studio-button-legacy
        #inputClear
        class="button-clear-text"
        slot="trigger"
        [class.show]="formCtrl.value || selectedChips.length"
        (click)="clearInput(true)"
        theme="transparent"
      >
        <studio-icon inputClear name="close" size="18"></studio-icon>
      </studio-button-legacy>
    </studio-tooltip>
  </div>
  <mat-autocomplete
    #auto="matAutocomplete"
    class="chip-list-autocomplete"
    (optionSelected)="selected($event)"
  >
    <mat-option
      *ngFor="
        let option of filteredOptions$
          | async
          | slice : 0 : (limitResults > 0 ? limitResults : filteredOptions$.getValue().length)
      "
      [value]="option[displayKey]"
    >
      <studio-checkbox
        [uniqueId]="option[displayKey]"
        [checked]="isOptionChecked(option[displayKey])"
      >
        <span class="inline">
          <span
            class="option-text"
            [innerHTML]="option.text || option.label | highlight : formCtrl.value"
          ></span>
          <span
            *ngIf="option.description"
            class="option-description"
            [innerHTML]="option.description | highlight : formCtrl.value"
          ></span>
        </span>
      </studio-checkbox>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
